import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { IssueSecurityLevelReportsData } from './IssueSecurityLevelReportsData.types.tsx';

const RESOURCE_TYPE_ISSUE_SECURITY_LEVEL_PROJECTS_LIMITS = 'ISSUE_SECURITY_LEVEL_PROJECTS_LIMITS';

export const issueSecurityLevelProjectsLimitsResource: RouteResource<IssueSecurityLevelReportsData> =
	createResource<IssueSecurityLevelReportsData>({
		type: RESOURCE_TYPE_ISSUE_SECURITY_LEVEL_PROJECTS_LIMITS,
		getKey: () => 'issueSecurityLevelProjectsLimits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-issue-security-level-projects-limits", jiraSpaEntry: "async-resource-issue-security-level-projects-limits" */ './getIssueSecurityLevelData.tsx'
			),
	});
